<template>
    <div>
        <b-card>
<!-- ------------------Header------------------- -->
            <div slot="header">
                <b>Version Management</b>
                <div class="card-header-actions">
                    <b-button variant="outline-dark" size="sm" @click="openupdateModal()">Upload Apk</b-button>
                </div>
            </div>
<!-- ------------------Loader------------------ -->
            <div id="listloader" v-if="loader">
                <div class="listloader"></div>
            </div>

<!-- -------------------Table------------------ -->
                    <b-col sm="12" class="text-right">
                        <p>
                            <b>Total Records : <span style="color:red;">{{ this.totalRecords }}
                            </span>
                            </b>
                        </p>
                    </b-col>
        <b-table responsive show-empty :items="items" :fields="fields" caption-top id="my-table" :bordered="bordered">
                <template slot="isactive" slot-scope="row">
                    <b-badge :variant="row.item.isactive == '1' ? 'success' : 'danger' " @click="activeinactive(row.item)" class="pt-1" style="cursor: pointer;">{{row.item.isactive == '1' ? 'Active':'Inactive'}}</b-badge>
                </template>
                <template slot="upload_apkfile" slot-scope="row">
                    <b-button @click="getApkLink(row.item)" variant="outline-dark" size="sm">
                    <i class="fa fa-eye" aria-hidden="true" style="cursor: pointer;"></i>
                    </b-button>
                </template>
                <!--<template slot="remove" slot-scope="row">
                    <b-button @click="removeData(row.item)" variant="outline-danger" size="sm" style="cursor: pointer">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </b-button>
                </template>-->
		</b-table>

<!-- -------------------Pagination------------------ -->
        <div class="overflow-auto">
            <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRecords"
                    :per-page="perPage"
                    @change="fetchData"
                    aria-controls="my-table"
                    ></b-pagination>
            <!-- <p class="mt-3">Current Page: {{ currentPage }}</p> -->
            </div>

<!-- -------------------Modal------------------ -->
            <b-modal size="lg" title="Apk Upload" centered v-model="openModal" hide-footer>
                <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                    <b-row>
                        <div id="listloader" v-if="loader">
                            <div class="listloader"></div>
                        </div>

                        <b-col sm="4">
                            <b-form-group>
                                <label for="Updated Apk Version Code">Updated Apk Version Code</label>
                                <span style="color:red;">*</span>    
                                <b-form-input type="text" name="Updated Apk Version Code" v-model="form.versionCode"   v-validate="'required|numeric'" :class="{ 'input': true, 'is-invalid': errors.has('form-1.Updated Apk Version Code') }" placeholder="Enter updated version code">
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                    <i class="fa fa-warning" v-show="errors.has('Updated Apk Version Code')"></i>
                                    </span>
                                    <span style="width:240px" v-show="errors.has('form-1.Updated Apk Version Code')" class="help text-danger">{{
                                    errors.first('form-1.Updated Apk Version Code') }}</span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="4">
                            <label for="Apk file">Upload Apk file</label>
                            <span style="color:red;">*</span>  
                            <b-form-file name="Apk file" v-model="form.apkfile" v-validate="'required' " placeholder="Upload Apk file" @change="selectFile($event,'Apk_file') " :class="{ 'input': true, 'is-invalid': errors.has('form-1.Apk file') }"></b-form-file>
                            <b-input-group class="mb-3">
                                    <span style="width:240px" v-show="errors.has('form-1.Apk file')" class="help text-danger">{{
                                    errors.first('form-1.Apk file') }}</span>
                                </b-input-group>
                        </b-col>
                        <b-col sm="4">
                            <b-form-group>
                                <label for="apkType">Apk Type</label>
                                <span style="color:red;">*</span>  
                                <b-form-select id="apkType" name="Apk Type" v-model="form.selected" :options="options" v-validate="'required' " :class="{ 'input': true, 'is-invalid': errors.has('form-1.Apk Type') }"></b-form-select>
                                <b-input-group class="mb-3">
                                    <span style="width:240px" v-show="errors.has('form-1.Apk Type')" class="help text-danger">{{
                                    errors.first('form-1.Apk Type') }}</span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="4">
                            <b-form-group>
                                <label for="Updated Apk Version Name">Updated Apk Version Name</label>
                                <span style="color:red;">*</span>  
                                    <b-form-input type="text" name="Updated Apk Version Name" v-model="form.updatedversionName" v-validate="'required|decimal'" :class="{ 'input': true, 'is-invalid': errors.has('form-1.Updated Apk Version Name') }" placeholder="Enter Updated Apk version Name">
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                    <i class="fa fa-warning" v-show="errors.has('Updated Apk Version Name')"></i>
                                    </span>
                                    <span style="width:240px" v-show="errors.has('form-1.Updated Apk Version Name')" class="help text-danger">{{
                                    errors.first('form-1.Updated Apk Version Name') }}</span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="4">
                            <b-form-group>
                                <label for="File Name">File Name</label>
                                <span style="color:red;">*</span>  
                                    <b-form-input type="text" name="File Name" v-model="form.fileName" v-validate="'required'" :class="{ 'input': true, 'is-invalid': errors.has('form-1.File Name') }" placeholder="Enter File Name">
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                    <i class="fa fa-warning" v-show="errors.has('File Name')"></i>
                                    </span>
                                    <span style="width:240px" v-show="errors.has('form-1.File Name')" class="help text-danger">{{
                                    errors.first('form-1.File Name') }}</span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="4">
                            <b-form-group>
                                <label for="Branch Name">Branch Name</label>
                                <span style="color:red;">*</span>  
                                    <b-form-input type="text" name="Branch Name" v-model="form.systemName" v-validate="'required'" :class="{ 'input': true, 'is-invalid': errors.has('form-1.Branch Name') }" placeholder="Enter Branch Name ">
                                    </b-form-input>
                                    <b-input-group class="mb-3">
                                    <span class="icon has-text-warning">
                                    <i class="fa fa-warning" v-show="errors.has('Branch Name')"></i>
                                    </span>
                                    <span style="width:240px" v-show="errors.has('form-1.Branch Name')" class="help text-danger">{{
                                    errors.first('form-1.Branch Name') }}</span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                       
                        <b-col sm="4">
                            <b-form-group>
                                <label for="forceUpdate">Force Update</label>
                                <span style="color:red;">*</span>  
                                <b-form-select id="forceUpdate" name="Force Update" v-model="form.force_Update" :options="forceOptions" v-validate="'required' " :class="{ 'input': true, 'is-invalid': errors.has('form-1.Force Update') }"></b-form-select>
                                <b-input-group class="mb-3">
                                    <span style="width:240px" v-show="errors.has('form-1.Force Update')" class="help text-danger">{{
                                    errors.first('form-1.Force Update') }}</span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group>
                                <label for="System Description">System Description</label>
                                <span style="color:red;">*</span>  
                                    <b-form-textarea type="text" name="System Description" v-model="form.sysDescription" v-validate="'required'" :class="{ 'input': true, 'is-invalid': errors.has('form-1.System Description') }" placeholder="Enter System Description">
                                    </b-form-textarea>
                                    <b-input-group>
                                    <span class="icon has-text-warning">
                                    <i class="fa fa-warning" v-show="errors.has('System Description')"></i>
                                    </span>
                                    <span style="width:240px" v-show="errors.has('form-1.System Description')" class="help text-danger">{{
                                    errors.first('form-1.System Description') }}</span>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div class="text-right">
                        <b-button variant="outline-dark" size="md" type="submit">Save</b-button>&nbsp;&nbsp;
                        <b-button variant="outline-danger" size="md" @click="openupdateModal()">Reset</b-button>
                    </div>
                </b-form>
                </b-modal>

<!-- -----------------Link Modal--------------- -->
            <b-modal size="lg" title="Apk File" centered v-model="openLinkModal" hide-footer>
                <table style="width: 90%;">
                    <tr>
                        <td>
							<b>Feature ID and Title</b>
						</td>
							<td class="text-center"><b style="color: crimson;">{{ apkdetails.system_description }}</b></td>
                    </tr>
                    <tr>
                        <td>
							<b>Feature Branch Name</b>
						</td>
							<td class="text-center">{{ apkdetails.system_name }}</td>
                    </tr>
                    <tr>
                        <td>
							<b>Version</b>
						</td>
                            <td class="text-center">{{ apkdetails.appversion }}</td>
							<!-- <td class="text-center">{{ apkdetails.id == '1' ? apkdetails.appversion : apkdetails.apkversion_code }}</td> -->
                    </tr>
                    <tr>
                        <td>
							<b>Version Name</b>
						</td>
							<td class="text-center">{{ apkdetails.apk_version_name }}</td>
                    </tr>
                    <tr>
                        <td>
							<b>Build Date</b>
						</td>
							<td class="text-center">{{ apkdetails.formattedDate }}</td>
                    </tr>
                    <tr>
                        <td>
							<b>Android Build(One Drive Link)</b>
						</td>
							<td class="textdeleteAppVersionSettings-center"> 
                                <div class="d-flex justify-content-center">
                                    <a :href="apkdetails.upload_apkfile" download>{{ apkdetails.upload_apkfile }}</a>&nbsp;&nbsp;

                    
                                    <b-button @click="copyToClipboard(apkdetails.upload_apkfile)" variant="outline-success" title="Copy APK File Link" size="sm">
                                        <i class="fa fa-clipboard" aria-hidden="true"></i>
                                    </b-button>
                                    <div v-if="showPopover" class="popover"> Copied! </div>
                                </div>
                            </td>
                    </tr>
                    <tr>
                        <td>
							<b>Environment Details</b>
						</td>
							<td class="text-center">{{ apkdetails.apk_type }}</td>
                    </tr>
                </table>
            </b-modal>
            </b-card>
            
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import CONSTANTS from '@/utils/constants';
    export default {
        data() {
            return {
                name: 'apk_url_upload',
                bordered:true,
                perPage: 15,
        		currentPage: 1,
                form: {
                apkfile: null,
                selected: null,
                force_Update: null,
                },
                items: [],
                fields: [
                { key: 'filename', label: 'File Name', sortable: true, tdClass: 'fileName'},
                { key: 'system_name', label: 'Branch Name', sortable: true, tdClass: 'branchName'},
                { key: 'appversion', label: 'Apk Version Code'},
                { key: 'apk_version_name', label: 'Apk Version Name'},
                { key: 'upload_apkfile', label: 'Apk File'},
                { key: 'isactive', label: 'Force Update'}
                ],
                options: [
                    { value: null, text: 'Please Select' },
                    { value: 'Live', text: 'Live' },
                    { value: 'Stage', text: 'Stage' }
                ],
                forceOptions: [
                    { value: null, text: 'Please Select' },
                    { value: '1', text: 'Yes' },
                    { value: '0', text: 'No' }
                ],
                openModal: false,
                loader: false,
                openLinkModal: false,
                apkdetails: {
                    formattedDate: '',
                },
                showPopover: false,
                totalRecords: 0

            }
        },
        created(){
           const userInfo = JSON.parse(localStorage.getItem("userData") || '{}')

        this.fetchData(this.currentPage)
        },
        
        methods: {

/*********************** Modal For Link ***************************/ 
            getApkLink(value){
                this.apkdetails = {}
                this.openLinkModal = true;
                this.apkdetails = value;

                const formattedDate = this.formatDate(this.apkdetails.createddate);
                this.apkdetails.formattedDate = formattedDate;

            },
            formatDate(dateString) {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = date.toLocaleString('default', { month: 'short' });
                const year = date.getFullYear();
                return `${day}-${month}-${year}`; 
            },
            copyToClipboard(link){
                navigator.clipboard.writeText(link).then(() => {
                    this.showPopover = true; // Show popover
                        setTimeout(() => {
                        this.showPopover = false; 
                        console.error("copied link.");// Hide popover after 1.5 seconds
                        }, 1500);
                        }).catch(() => {
                        console.error("Failed to copy the link.");
                });
            },

/***************************** Force Update ******************************/ 
            activeinactive(value){
                // this.loader = true;
                Swal.fire({
                    title: "<h3>Confirm Approval</h3><hr>",
                    html: `
                        Are you sure you want to Force Update? 
                        <br/><br/>
                    `,
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                    confirmButtonColor: "#00c0ef",
                    cancelButtonText: "Close",
                    cancelButtonColor: "#F8943F",
                }).then((result) => {
                    if (result.isConfirmed) { 
                        this.loader = true;
                         // var userdata = localStorage.getItem('userData')
                       // var userInfo = JSON.parse(userdata) 
                        let obj =  {
                            id: value.id,
                            forceUpdate: value.isactive == true?'0':'1'
                        };
                        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/updateAppSettings`, obj).then(result => {
                            this.loader = false;
                            if (result.body.returnmsg === 'Successful') {
                                this.$fire({
                                text: result.body.returnmsg,
                                type: "success",
                                timer: 30000
                                });
                                this.fetchData(1);
                            }
                            else{
                                 this.$fire({
                                    text: result.body.returnvalue,
                                    type: "error",
                                    timer: 30000
                                 });
                            }
                        })
                        
                    }
                    else{
                        this.loader = false;
                    }
                })
            },
//********************************** Get Data ******************************************** */ 
            fetchData(page = this.currentPage){
                this.loader = true;            
                this.currentPage = page
                const obj = {
                    pageno: page,
                    limit: this.perPage
                };
                this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAppVeSettingsNew`, obj).then((result) =>{
                    this.loader = false;
                    if (result.body.returnmsg === 'Successful'){
						console.log("result", result);
						this.items = result.body.returnvalue;
                        this.totalRecords = result.body.totalcount;
                    }
                    else{
						this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000
                        });
						this.items = [];
					}
                }).catch(ex => {})

            },

//********************************** Open Update Apk Modal************************************** */
            openupdateModal(){
                this.form={
                     apkfile: null,
                selected: null,
               
                force_Update: null,
                };
                this.openModal = true;
            },
        
        
//********************************** Validation ********************************** */
            validateForm(scope){
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this.uploadApk();
                }
                })
            },
            selectFile(event,name){
            this.loader=true;
            let tempFile = event.target.files[0];
            if(tempFile!=null){
                let filedata = new FormData();
                let config = {
                    header : {
                        'Content-Type' : 'multipart/form-data'
                    }
                }
                filedata.append('file', tempFile)
                this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/appversionuploadImageToS3`,filedata, {header : {
                        'Content-Type' : 'multipart/form-data'
                    },
                })
                .then(Response => {
                    console.log("===================",Response)
                    this.loader=false;
                    if(Response.body.result === 'success'){   
                        this.apkfile = Response.body.image_url;
                        console.log("apkfile", this.apkfile);
                    }
                    else{
                        // this.loader = true;
                    }
                })
                }
            },

/****************************** Upload Apk **********************************/ 
            uploadApk(){
           // var userdata = localStorage.getItem('userData')
            // var userInfo = JSON.parse(userdata) 

                let obj = {
                    appVersionCode: this.form.versionCode,
                    apkUrl: this.apkfile,
                    apkType: this.form.selected,
                    systemName: this.form.systemName,
                    forceUpdate: this.form.force_Update,
                    fileName: this.form.fileName,
                    apkVersionName: this.form.updatedversionName,
                    systemDescription: this.form.sysDescription
                };
                this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/addAppVersionSettings`, obj).then(( result ) => {
                    if (result.body.returnmsg === "Successful"){
                            this.$fire({
                                text: result.body.returnmsg,
                                type: "success",
                                timer: 30000
                            });
                            this.openModal = false;
                            this.fetchData(1);
                    }
                    else{
                            this.$fire({
                                text: result.body.returnvalue,
                                type: "error",
                                timer: 30000
                            });
                    }
                })
            },
/************************* Delete Entry *****************************/ 
            removeData(value){
                Swal.fire({
                    title: "<h3>Confirm Approval</h3><hr>",
                    html: `
                        Are you sure you want to Delete? 
                        <br/><br/>
                    `,
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                    confirmButtonColor: "#00c0ef",
                    cancelButtonText: "Close",
                    cancelButtonColor: "#F8943F",
                }).then((result) => {
                    if(result.isConfirmed){
                        const object = {
                            id: value.id
                        }
                        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/deleteAppVersionSettings`,object).then((result) => {
                            if (result.body.returnmsg === 'Successful'){
                                this.$fire({
                                text: result.body.returnmsg,
                                type: "success",
                                timer: 30000
                                });
                                this.fetchData(1);
                            }
                            else{
                                this.$fire({
                                text: "App version already exists!",
                                type: "error",
                                timer: 30000
                                });
                                this.items = [];
					        }
                        }).catch(ex => {})
                    }
                })
            }
        }
    }
</script>
<style>  
  
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 2px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.popover {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

</style>